// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Estado } from "../interfaces/Estado";
import { estadoService } from "../services/estadoService";

export const useEstados = () => {
  const { isLoading, data, error } = useFetch<Estado[]>(
    true,
    estadoService,
    [] // dependências
  );

  return { isLoading, data, error };
};
